var current,image,imgObj,imgSource,reader,file,text = "Enter Your Text",id,
    canvas,canvas1,imgData,imgWidth,alignment,activeOb,target,fontSize,object,type,sCAle,
    textInput = document.getElementById('text_box'),effect,
    fill,fSize,fStyle,fWeight,tAlign,shade,f,action,left,top,oX,oY,sX,sY,
    undoButton = document.getElementById('undo'),
    redoButton = document.getElementById('redo'),
    Family = document.getElementById('fontFamily').value,
    bold = document.getElementById('bold'),
    italic = document.getElementById('italic'),
    cHeight = window.innerHeight * 0.50,
    cWidth = cHeight * 1.96;
var filters = ['grayscale', 'invert', 'remove-color', 'sepia', 'brownie',
               'brightness', 'contrast', 'vintage', 'technicolor', 'polaroid',
               'kodachrome', 'blackwhite'];

var diameter = +$('#diameter').val();
var kerning = +$('#kerning').val();
var flipped = $('#flip').is(':checked');


function getActiveCanvasInfo() {
  const activeSection = document.querySelector(".side.active");
  if (!activeSection) return null;

  const canvasEl = activeSection.querySelector("canvas");
  if (!canvasEl) return null;

  const id = canvasEl.id.replace("Canvas", ""); // top / sid / frt
  const canvas = window['canvases']?.[id];

  if (!canvas) return null;

  return { canvas, id };
}


jQuery(document).on('change', '#backgroundColor', function () {

  const color = jQuery(this).val();

  if (!window.canvases) return;

  Object.entries(window.canvases).forEach(([name, canvas]) => {

    if (!canvas) return;

    const finalColor = (color === 'transparent') ? null : color;

    canvas.setBackgroundColor(finalColor, function () {

      canvas.renderAll();

      if (typeof updatedPreivew === "function") {
        updatedPreivew(canvas);
      }

    });

    canvas._bgColor = finalColor;

  });

});


function getCanvas() {
  const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
  return window.canvases[activeSide] || null;
}

function getActiveSide(){
  return document.querySelector('.side.active')?.id?.replace('Section','') || 'top';
}

// const canvas = getCanvas();
const side = getActiveSide();

canvasBlock(canvas, side);

const portraitSizes = ["55x85","24x36","36x48","18x24","50x70","40x56","12x16"];
const landscapeSizes = ["85x55","36x24","48x36","24x18","70x50","56x40","16x12"];
const squareSizes = ["40x40","50x50","55x55"];


const baseDims = {
  top:   { width: 500, height: 714 },
  sid:  { width: 714, height: 500 },
  frt: { width: 500, height: 500 }
};


// Define base canvas dimensions per size variant
const canvasSizes = {
  "50x70": { width: 500, height: 700 },
  "40x56": { width: 400, height: 560 },
  "12x16": { width: 120, height: 160 },
  "85x55": { width: 850, height: 550 },
  "36x24": { width: 360, height: 240 },
  "48x36": { width: 480, height: 360 },
  "24x18": { width: 240, height: 180 },
  "40x40": { width: 400, height: 400 },
  "50x50": { width: 500, height: 500 },
  "55x55": { width: 550, height: 550 },
};

// Initialize canvases
// window.canvases = {
//   top: new fabric.Canvas('topCanvas'),
//   sid: new fabric.Canvas('sidCanvas'),
//   frt: new fabric.Canvas('frtCanvas')
// };

// Get active canvas (currently showing)
function getActiveCanvas() {
  const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
  return window.canvases[activeSide];
}

// Center object on canvas
function centerObjectOnCanvas(obj, canvas) {
  if (!canvas || !obj) return;
  obj.set({
    left: canvas.getWidth() / 2,
    top: canvas.getHeight() / 2,
    originX: 'center',
    originY: 'center'
  });
  canvas.add(obj);
  canvas.setActiveObject(obj);
  canvas.renderAll();
}

// Update all previews
// function updateAllPreviews() {

//   Object.entries(window.canvases).forEach(([side, canvas]) => {

//     const data = canvas.toDataURL("image/png");

//     jQuery(`.${side}CanvasPreview`).each(function(){
//       jQuery(this).attr('src', data);
//     });

//   });

// }

// Resize all canvases
function resizeAllCanvases(width, height) {
  Object.values(window.canvases).forEach(canvas => {
    if (!canvas) return;
    canvas.setWidth(width);
    canvas.setHeight(height);
    canvas.calcOffset();
    canvas.renderAll();
  });
  // updateAllPreviews();
}




function addSafeArea(canvas, name) {

  if (!canvas) return;

  if (canvas._safeArea) {
    canvas.remove(canvas._safeArea);
    canvas._safeArea = null;
  }

  const zoom = canvas.getZoom() || 1;

  // ✅ REAL INTERNAL SIZE (important fix)
  const width = canvas.width;
  const height = canvas.height;

  const padding = 2;

  const safeRect = new fabric.Rect({
    left: padding / zoom,
    top: padding / zoom,
    width: (width / zoom) - (padding * 2 / zoom),
    height: (height / zoom) - (padding * 2 / zoom),

    fill: 'transparent',
    stroke: 'grey',
    strokeDashArray: [6,6],
    strokeWidth: 1 / zoom, // ✅ VERY IMPORTANT (fixes mobile shrink bug)

    selectable: false,
    evented: false,
    excludeFromExport: true
  });

  canvas._safeArea = safeRect;
  canvas.add(safeRect);

  safeRect.bringToFront();
  safeRect.setCoords();
}



// Listen for size variant changes
// AFTER canvas initialization
setTimeout(() => {

  document.querySelectorAll('input[name="Sizes (in inches)"]').forEach(radio => {
    radio.addEventListener('change', function() {

      const sizeValue = this.value;
      const newDims = canvasSizes[sizeValue] || { width: 500, height: 500 };

      resizeAllCanvases(newDims.width, newDims.height);

    });
  });

}, 100); // small delay ensures canvases exist

// Initial setup: set default selected variant
const defaultVariant = document.querySelector('input[name="Sizes (in inches)"]:checked');
if (defaultVariant) {
  defaultVariant.dispatchEvent(new Event('change'));
}

// Optional: add images to canvas (auto-center)
function addImageToActiveCanvas(imgURL) {
  const canvas = getActiveCanvas();
  if (!canvas) return;

  fabric.Image.fromURL(imgURL, function(img) {
    const width = canvas.getWidth();
    img.scaleToWidth(width / 2);
    centerObjectOnCanvas(img, canvas);
    // updateAllPreviews();
  });
}



// Default Desktop Base Reference
let mainWide = 300;
let mainHigh = 429;

// === Calculate Responsive Size Based on Screen ===
function getResponsiveCanvasSize(side) {
  const dim = baseDims[side] || baseDims.top;
  const screenW = window.innerWidth;

  let scaleFactor = 1;
  if (screenW <= 600) scaleFactor = 0.55;     // mobile
  else if (screenW <= 992) scaleFactor = 0.75; // tablet

  return {
    width: dim.width * scaleFactor,
    height: dim.height * scaleFactor
  };
}

// // === Store All Canvases Globally ===
window.canvases = {};


function resizeAllCanvases(newWidth, newHeight) {


  if (!window.canvases || Object.keys(window.canvases).length === 0) return;

  Object.entries(window.canvases).forEach(([name, canvas]) => {

    if (!canvas) return;

    canvas.setWidth(newWidth);
    canvas.setHeight(newHeight);

    canvas.calcOffset(); // ✅ IMPORTANT for mobile

    // ❌ DO NOT render here
    // ❌ DO NOT add safeArea here

  });

}


function updateCanvasOrientation(type){

  let newWidth, newHeight;

  if(type === "portrait"){
    newWidth = 500;
    newHeight = 714;
  }
  else if(type === "landscape"){
    newWidth = 714;
    newHeight = 500;
  }
  else if(type === "square"){
    newWidth = 500;
    newHeight = 500;
  }

  const screenW = window.innerWidth;
  let scaleFactor = 1;

  if (screenW <= 600) scaleFactor = 0.55;
  else if (screenW <= 992) scaleFactor = 0.75;

  newWidth *= scaleFactor;
  newHeight *= scaleFactor;

  resizeAllCanvases(newWidth, newHeight);

  const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');

  // ✅ IMPORTANT: sync AFTER resize
  syncAllCanvases(activeSide);

  // ❌ REMOVE this (causing bug)
  // Object.values(window.canvases).forEach(c => updatedPreivew(c));
}


jQuery(document).on('change','input[name="Sizes (in inches)"]',function(){

  const val = jQuery(this).val().trim();

  let sideToShow = "top";

  if(portraitSizes.includes(val)){
    updateCanvasOrientation("portrait");
    sideToShow = "top";
  }
  else if(landscapeSizes.includes(val)){
    updateCanvasOrientation("landscape");
    sideToShow = "sid";
  }
  else if(squareSizes.includes(val)){
    updateCanvasOrientation("square");
    sideToShow = "frt";
  }

  // ✅ SWITCH CANVAS
  document.querySelectorAll('.side').forEach(div => {
    div.style.display = 'none';
    div.classList.remove('active');
  });

  const activeSection = document.getElementById(sideToShow + 'Section');
  activeSection.style.display = 'block';
  activeSection.classList.add('active');

  const canvas = window.canvases[sideToShow];

  if (canvas) {
    canvas.renderAll();
    canvasBlock(canvas, sideToShow);
    updatedPreivew(canvas); // ✅ IMPORTANT
  }

});



/*function syncAllCanvases(activeCanvasName) {

  const sourceCanvas = window.canvases[activeCanvasName];
  if (!sourceCanvas) return;

  const objects = sourceCanvas.getObjects().filter(obj => !obj.excludeFromExport);

  Object.entries(window.canvases).forEach(([name, targetCanvas]) => {

    if (!targetCanvas || name === activeCanvasName) return;

    // ❌ remove only design objects
    targetCanvas.getObjects().forEach(obj => {
      if (!obj.excludeFromExport) {
        targetCanvas.remove(obj);
      }
    });

    // ✅ clone with correct layer order
    objects.forEach((obj, index) => {

      obj.clone(function(cloned) {

        cloned.set({
          left: targetCanvas.getWidth() / 2,
          top: targetCanvas.getHeight() / 2,
          originX: 'center',
          originY: 'center'
        });

        // 🔥 maintain exact layer order
        targetCanvas.insertAt(cloned, index, false);

        // optional: lock watermark/safeArea above
        if (targetCanvas._safeArea) {
          targetCanvas._safeArea.bringToFront();
        }

        targetCanvas.renderAll();
      });

    });

  });

}*/

function syncAllCanvases(activeCanvasName) {


  const sourceCanvas = window.canvases[activeCanvasName];
  if (!sourceCanvas) return;

  const sourceObjects = sourceCanvas
    .getObjects()
    .filter(obj => !obj.excludeFromExport);

  Object.entries(window.canvases).forEach(([name, targetCanvas]) => {

    if (!targetCanvas || name === activeCanvasName) return;

    // ❌ remove old objects
    targetCanvas.getObjects().forEach(obj => {
      if (!obj.excludeFromExport) targetCanvas.remove(obj);
    });

    // ✅ clone WITHOUT scaling (THIS FIXES ZOOM ISSUE)
    sourceObjects.forEach((obj, index) => {

      obj.clone(function(cloned) {

        cloned.set({
          left: obj.left,
          top: obj.top,
          scaleX: obj.scaleX,
          scaleY: obj.scaleY,
          originX: obj.originX,
          originY: obj.originY
        });

        targetCanvas.insertAt(cloned, index, false);
      });

    });

    // keep safe area on top
    if (targetCanvas._safeArea) {
      targetCanvas._safeArea.bringToFront();
    }

    targetCanvas.renderAll();
  });
  
}



// === Initialize Each Canvas ===
Object.keys(baseDims).forEach(name => {
  const size = getResponsiveCanvasSize(name);
  const canvasEl = document.getElementById(`${name}Canvas`);
  if (!canvasEl) return;

  const c = new fabric.Canvas(canvasEl, {
    width: size.width,
    height: size.height,
    backgroundColor: "rgba(0,0,0,0.05)",
    selection: true,
    preserveObjectStacking: true,
  });

  window.canvases[name] = c;
  window[name + 'Canvas'] = c;

  if (typeof addModify === "function") addModify(c, name); // ✅ pass name
  if (window.drawHistory && typeof drawHistory.initCanvasState === "function") {
    drawHistory.initCanvasState(name);
  }

  c.renderAll();
});

function getActiveCanvas() {
  const activeSide = getActiveSide();
  return window.canvases[activeSide];
}

function getCanvasSize(canvas) {
  return { width: canvas.width, height: canvas.height };
}


// ON LOAD
jQuery(window).on('load', function(){

  const canvas = window.canvases.top;

  if (!canvas) return;

  const activeSide = getActiveSide();
canvasBlock(canvas, activeSide);

  jQuery('#loader').hide();
});

// ON RESIZE
jQuery(window).resize(function(){
    var id = jQuery('.side.active').find('canvas').attr('id');
    const activeSide = document.querySelector('.side.active')?.id?.replace('Section','') || 'top';
    canvasBlock(canvas, activeSide);
    var canvas = window.canvases[name];
    canvasBlock(canvas,name);
});



tooltip();
jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

var shirtColorListName = ['Black', 'White'];
var shirtColorListCode = [
  '#08090d', // Black
  '#e7e9ed' // White
  ];



jQuery(document).on('click','.drawingButton .main_buttons',function(){

  const canvas = getCanvas();
  if (!canvas) return;

  const activeSide = getActiveSide(); // ✅ important

  canvasBlock(canvas, activeSide); // ✅ correct side

  jQuery('.popupImg').css('visibility','visible');
  jQuery('#tadaWidget').hide();
});


let sideCheck = 0;

jQuery(document).on('click','.tool_option>.closePreview',function(){

  const canvas = getCanvas();
  if (!canvas) return;

  sideCheck = 0;

  canvas.discardActiveObject();

  canvas.renderAll();

  // ✅ keep background (DO NOT reset it)

  if (typeof updatedPreivew === "function") {
    updatedPreivew(canvas);
  }

  jQuery('.popupImg').css('visibility','hidden');

});

jQuery('.popupBox').each(function(){
  jQuery(this).draggable({
    start: function() {
      /*jQuery(this).css('position','');
      jQuery(this).css('right','');*/
    },
    handle: "div.drag-me"
  });
});

jQuery('.popupBox input,.popupBox select,.popupBox textarea,.colorpicker,.colorpicker *').on('mousedown touchstart', function(e){
  e.stopPropagation();
});

jQuery(document).on('click','.tool_option>h4',function(){
  current = jQuery(this).next();
  jQuery('.popupBox').each(function(){
    jQuery(this).hide();
  });
  current.show();
  if(jQuery(window).width() < '767'){
    jQuery('#cImagePop').css({
      'top': '-410px',
      'left': '98px'
    });
  }
});

jQuery(document).on('click','.closeTpop',function(e){
  e.stopPropagation();

  const canvas = getCanvas();
  if (!canvas) return;

  jQuery(this).parent().hide();
  canvas.discardActiveObject().renderAll();
});

jQuery(document).on('change','#uploadFile',function(event){
  file = event.target.files[0];
  reader = new FileReader();
  reader.onloadend = function(){
    imgSource = reader.result;
  };
  reader.readAsDataURL(file);
});

jQuery(document).on('change','#terms',function(){
  var term = jQuery(this).prop('checked');
  if(term){
    jQuery('#uploadNow').removeAttr('disabled');
  }else{
    jQuery('#uploadNow').attr('disabled','disabled');
  }
});

jQuery(document).on('click','#uploadNow',function(){

  const canvas = getCanvas();
  if (!canvas) return;

  reader = new FileReader();
  const zoom = canvas.getZoom();

  reader.onload = function (event){
    imgObj = new Image();
    imgObj.src = event.target.result;

    imgObj.onload = function(){
      image = new fabric.Image(imgObj);

      image.set({
        originX:"center",
        originY:"center",
        left: canvas.getWidth() / 2,
        top: canvas.getHeight() / 2
      });

      image.scaleToWidth(canvas.getWidth() / 2);

      canvas.add(image).setActiveObject(image);
      canvas.renderAll();
    }
  }

  if(file) reader.readAsDataURL(file);
});

jQuery(document).on('click','#changeText',function(){

  const canvas = getCanvas();
  if (!canvas) return;

  addText(canvas);
});

jQuery(document).on('change','#clipart_category',function(){
  Showcontainer();
});

function tooltip(){
  var tipContent;
  jQuery('.toolTip').each(function(){
    tipContent = jQuery(this).attr('tooltip');
    jQuery(this).after('<div class="tooltipLabel">'+tipContent+'</div>');
  });
}
  
function Showcontainer(){
  var selectedOption = document.getElementById("clipart_category").value;
  jQuery('.drop_down_catgory>div').each(function(){
    jQuery(this).hide();
  });
  document.getElementById(selectedOption).style.display = "block";
}

var clonedObject = _.cloneDeep(object);
function cloneFabricObject(object) {
  return fabric.util.object.clone(object);
}

jQuery(document).on('click','.actionBtns>a',function(){
    if(jQuery(this).parent().hasClass('disabled')) return false;

    const action = jQuery(this).attr('data-obj');
    const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
    const canvas = window.canvases?.[activeSide];
    if (!canvas) return;

    const activeOb = canvas.getActiveObject();
    if (!activeOb) return;

    const zoom = canvas.getZoom();
    
    switch(action){
        case 'front': canvas.bringToFront(activeOb); break;
        case 'flip': activeOb.toggle('flipX'); break;
        case 'alignH': activeOb.left = (canvas.getWidth()/2)/zoom; break;
        case 'alignV': activeOb.top = (canvas.getHeight()/2)/zoom; break;
        case 'moveL': activeOb.left -= 2; break;
        case 'moveR': activeOb.left += 2; break;
        case 'moveT': activeOb.top -= 2; break;
        case 'moveB': activeOb.top += 2; break;
        case 'trash': canvas.remove(activeOb); break;
        case 'copy': 
            const cloned = cloneFabricObject(activeOb);
            cloned.set({ left: cloned.left + 15, top: cloned.top + 15 });
            canvas.add(cloned).setActiveObject(cloned);
            canvas.discardActiveObject().renderAll();
            break;
    }

    activeOb.setCoords();
    canvas.renderAll();
    drawHistory.updateCanvasState(canvas, id);
});

function canvasMakeImg(canvas,zoom,name){
  const baseWidth = baseDims[name]?.width;
  newZoomLevel = zoom / baseWidth;
  setZoomMask(canvas,newZoomLevel,name);
}

function canvasBlock(canvas, name) {

  if (!canvas) return;

  let containerWidth = document.querySelector('.canvas_div')?.offsetWidth || 300;
  let baseWidth = baseDims[name]?.width || 500;

  let newZoomLevel = containerWidth / baseWidth;

  setZoomMask(canvas, newZoomLevel, name); // ✅ everything handled inside
}


function showCanvas(sideName) {

  document.querySelectorAll('.side').forEach(div => {
    div.style.display = 'none';
    div.classList.remove('active');
  });

  const section = document.getElementById(sideName + 'Section');
  section.style.display = 'block';
  section.classList.add('active');

  const canvas = window.canvases[sideName];

  if (canvas) {
    canvas.renderAll();

    // ✅ important for Fabric
    canvas.calcOffset();

    canvasBlock(canvas, sideName);

    // ✅ update preview correctly
    updatedPreivew(canvas);
  }
}

document.getElementById('topButton')?.addEventListener('click', () => showCanvas('top'));
document.getElementById('sidButton')?.addEventListener('click', () => showCanvas('sid'));
document.getElementById('frtButton')?.addEventListener('click', () => showCanvas('frt'));

// === Auto Adjust on Window Resize ===
/*window.addEventListener('resize', () => {
  const active = document.querySelector('.side.active');
  if (active) {
    const sideName = active.id.replace('Section', '');
    canvasBlock(window.canvases[sideName],);
  }
});*/


function setZoomMask(canvas, newZoomLevel, name) {

  if (!canvas) return;

  const baseWidth = baseDims[name]?.width || 500;
  const baseHeight = baseDims[name]?.height || 500;

  // reset zoom
  canvas.setZoom(1);

  // set dimensions
  canvas.setDimensions({
    width: baseWidth * newZoomLevel,
    height: baseHeight * newZoomLevel
  });

  // apply zoom
  canvas.setZoom(newZoomLevel);

  canvas.calcOffset();

  // ✅ IMPORTANT: delay safeArea (fix preview bug)
  setTimeout(() => {

    addSafeArea(canvas, name);

    canvas.renderAll();

    // ✅ preview AFTER everything is ready
    if (typeof updatedPreivew === "function") {
      updatedPreivew(canvas);
    }

  }, 50); // 👈 key fix
}


function centerObjectOnActiveCanvas(obj) {
  const canvas = getActiveCanvas();
  if (!canvas || !obj) return;

  const { width, height } = getCanvasSize(canvas);
  obj.set({
    left: width / 2,
    top: height / 2,
    originX: "center",
    originY: "center",
  });

  canvas.add(obj);
  canvas.setActiveObject(obj);
  canvas.renderAll();
  if (typeof updatedPreivew === "function") updatedPreivew(canvas);
}


function addImageToActiveCanvas(imgURL) {
  const canvas = getActiveCanvas();
  if (!canvas) return;

  fabric.Image.fromURL(imgURL, function (img) {
    const { width } = getCanvasSize(canvas);
    img.scaleToWidth(width / 2);
    centerObjectOnActiveCanvas(img);
  });
}

$(document).ready(function () {

  // ✅ Detect selected size
  const selectedSize = document.querySelector('input[name="Sizes (in inches)"]:checked')?.value;

  let sideToShow = "top";

  if (landscapeSizes.includes(selectedSize)) sideToShow = "sid";
  else if (squareSizes.includes(selectedSize)) sideToShow = "frt";

  // ✅ Hide all canvases
  document.querySelectorAll('.side').forEach(div => {
    div.style.display = 'none';
    div.classList.remove('active');
  });

  // ✅ Show only correct canvas
  const activeSection = document.getElementById(sideToShow + 'Section');
  activeSection.style.display = 'block';
  activeSection.classList.add('active');

  const canvas = window.canvases[sideToShow];

  if (canvas) {
    canvas.renderAll();
    canvasBlock(canvas, sideToShow);
    updatedPreivew(canvas); // ✅ IMPORTANT
  }

});


// function updatedPreivew(canvas) {
//   if (!canvas) return;

//   const id = canvas.lowerCanvasEl.id;
//   const side = id.replace('Canvas', '');

//   const imgData = canvas.toDataURL("image/png");

//   // ✅ hide all previews
//   jQuery('.topCanvasPreview, .sidCanvasPreview, .frtCanvasPreview').hide();

//   // ✅ show only active
//   jQuery(`#${side}CanvasPreview`)
//     .attr('src', imgData)
//     .show();
// }


function updatedPreivew(canvas) {
  if (!canvas) return;

  const id = canvas.lowerCanvasEl.id;
  const side = id.replace('Canvas', '');

  // 🔥 FORCE render before export (important)
  canvas.renderAll();

  // 🔥 FIX: include background properly
  const imgData = canvas.toDataURL({
    format: 'png',
    multiplier: 1,
    enableRetinaScaling: false
  });

  // ✅ hide all previews
  jQuery('.topCanvasPreview, .sidCanvasPreview, .frtCanvasPreview').hide();

  // ✅ show only active
  jQuery(`#${side}CanvasPreview`)
    .attr('src', imgData)
    .show();
}

// function updatedPreivew(canvas) {
//   const imgData = canvas.toDataURL("image/png");
//   const id = canvas?.lowerCanvasEl?.id;
//   if (!id) return;
//   const zoom = jQuery('.product__media-item.is-active>.product-media-container').innerWidth();
//   let imgWidth = zoom * 0.2069;

//   // Update preview for current canvas
//   jQuery('.' + id + 'Preview').attr('src', imgData);
//   if (jQuery('.s2PreviewK').length > 0) {
//     imgWidth = zoom * 0.1650;
//   }
//   jQuery('#' + id + 'Preview').css('width', imgWidth + 'px');
// }



function renderIcon(icon){
  return function (ctx, left, top, styleOverride, fabricObject){
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

var filteringBox = document.getElementById('imgFilterPop');

function addModify(canvas, sideName) {
  if (!(canvas instanceof fabric.Canvas)) {
    console.error("addModify: Not a fabric canvas object");
    return;
  }

  // Fabric setup
  fabric.Object.prototype.padding = 5;
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;
  canvas.renderOnAddRemove = false;

  // --- SELECTION CLEARED ---
  canvas.on("selection:cleared", function () {
    jQuery(".actionBtns").addClass("disabled");
    fabric.util.toArray(filteringBox.getElementsByTagName("input")).forEach(function (el) {
      el.disabled = true;
    });
    jQuery(".thePop").each(function () {
      jQuery(this).find(".colorOFF").trigger("click");
      jQuery(this).hide();
    });
  });

  // --- OBJECT SELECT EVENTS ---
  canvas.on("selection:created", function () {
    const object = canvas.getActiveObject();
    selectedObj(object);
  });

  canvas.on("selection:updated", function () {
    const object = canvas.getActiveObject();
    selectedObj(object);
  });

  // --- OBJECT SCALING ---
  canvas.on("object:scaling", function () {
    canvas.renderAll();
  });

  // --- OBJECT ADDED / MODIFIED ---
  canvas.on("object:added", function (e) {
    const object = e.target;
    if (window.drawHistory && typeof drawHistory.updateCanvasState === "function") {
      drawHistory.updateCanvasState(canvas, sideName);
    }
    if (typeof undoButton !== "undefined" && undoButton) {
      undoButton.removeAttribute("disabled");
    }
    if (typeof addControls === "function") {
      addControls(object);
    }
    updatedPreivew(canvas); // ✅ Update all previews
    canvas.renderAll();
  });

  canvas.on("object:modified", function (e) {
    if (window.drawHistory && typeof drawHistory.updateCanvasState === "function") {
      drawHistory.updateCanvasState(canvas, sideName);
    }
    updatedPreivew(canvas); // ✅ Update all previews
    canvas.renderAll();
  });

  // --- OBJECT REMOVED ---
  canvas.on("object:removed", function (e) {
    if (window.drawHistory && typeof drawHistory.updateCanvasState === "function") {
      drawHistory.updateCanvasState(canvas, sideName);
    }
    updatedPreivew(canvas); // ✅ Update all previews
    canvas.renderAll();
  });
}


function getActiveCanvasInfo() {
  const activeSection = document.querySelector(".side.active");
  if (!activeSection) return null;

  const activeCanvas = activeSection.querySelector("canvas");
  if (!activeCanvas) return null;

  const id = activeCanvas.id.replace("Canvas", ""); // e.g. "top", "side", "front"
  const canvas = window.canvases[id];
  return { canvas, id };
}

drawHistory.undoButton.addEventListener("click", function () {
  const active = getActiveCanvasInfo();
  if (active) drawHistory.undo(active.canvas, active.id);
});

drawHistory.redoButton.addEventListener("click", function () {
  const active = getActiveCanvasInfo();
  if (active) drawHistory.redo(active.canvas, active.id);
});



function selectedObj(object){
  jQuery('.thePop').each(function(){
    jQuery(this).hide();
  });
  jQuery('.actionBtns').removeClass('disabled');
  type = object.type;
  if(type == 'text'){
    jQuery('#italic').prop('checked',false);
    jQuery('#bold').prop('checked',false);

    
    fill = object.fill;
    Family = object.fontFamily;
    fSize = object.fontSize;
    fStyle = object.fontStyle;
    fWeight = object.fontWeight;
    text = object.text;
    tAlign = object.textAlign;

    jQuery('#textColor .currentColor').val(fill);
    jQuery('#textColor .currentColor+.colorBox').css('backgroundColor',fill);
    jQuery('#fontFamily').val(Family);
    jQuery('#fSize').val(fSize);
    jQuery('input[name="text-align"][value="'+tAlign+'"]').prop('checked',true);
    
    if(fStyle == 'italic'){
      jQuery('#italic').prop('checked',true);
    }
    if(fWeight == 'bold'){
      jQuery('#bold').prop('checked',true);
    }
    
    textInput.value = text;
    
    jQuery('#textPop').show();
  }
  if(type == 'path'){
    var isColor = /[0-9A-Fa-f]{6}/g;
    fill = object.stroke;
    shade = object.shadow.color;
    if(isColor.test(fill)){
      jQuery('#line-color .currentColor').val(fill);
      jQuery('#line-color .currentColor+.colorBox').css('backgroundColor',fill);
      jQuery('#shade-color .currentColor').val(shade);
      jQuery('#shade-color .currentColor+.colorBox').css('backgroundColor',shade);
      jQuery('#drawing-colors').show();
    }
  }
  if(type == 'image'){
    fabric.textureSize = 75497472;
    fabric.util.toArray(filteringBox.getElementsByTagName('input')).forEach(function(el){
      el.disabled = false;
    });
    for (var i = 0; i < filters.length; i++) {
      if($(filters[i]) && ($(filters[i]).checked = !!object.filters[i])){
        $('#'+filters[i]).prop('checked',true);
      }else{
        $('#'+filters[i]).prop('checked',false);
      }
      console.log($(filters[i]) && ($(filters[i]).checked = !!object.filters[i]));
    };
    jQuery('#imgFilterPop').show();
  }
  //console.log(object);
}

jQuery(document).on('change','#effect',function(){
  const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
    const canvas = window.canvases?.[activeSide];
    if (!canvas) return;

    const activeOb = canvas.getActiveObject();
  effect = jQuery(this).val();
  object = canvas.getActiveObject();
  
  fill = object.fill;
  Family = object.fontFamily;
  fSize = object.fontSize;
  fStyle = object.fontStyle;
  fWeight = object.fontWeight;
  text = object.text;
  left = object.top;
  top = object.left;
  oX = object.originX;
  oY = object.originY;
  sX = object.scaleX;
  sY = object.scaleY;
  
  if(effect == 'curved'){
    const zoom = canvas.getZoom();
    const curvedText = new fabric.CurvedText(text, {
      left: (canvas.getWidth() / 2) / zoom,
      top: (canvas.getHeight() / 2) / zoom,
      fill: fill,
      fontFamily: Family,
      fontSize: fSize,
      fontStyle: fStyle,
      fontWeight: fWeight,
      originX: oX,
      originY: oY,
      radius: 150,
      startAngle: -90,
      spacing: 15,
      clockwise: true,
    });
    canvas.add(curvedText).setActiveObject(curvedText).renderAll();
  }
});

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}
  
function addText(canvas,name){
  const zoom = canvas.getZoom();
  var textObject = new fabric.Text('Enter Your Text',{
    left: (canvas.getWidth() / 2) / zoom,
    top: (canvas.getHeight() / 2) / zoom,
    originX:"center",
    originY:"center",
    scaleX: 1,
    scaleY: 1,
    fill: '#000',
    fontSize: 20,
    fontFamily: "'Arial',sans-serif",
    fontWeight: 'normal',
    textAlign: 'center'
  });
  canvas.add(textObject).setActiveObject(textObject).renderAll();
}

textInput.addEventListener('input', function(){
    const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
    const canvas = window.canvases?.[activeSide];
    if (!canvas) return;

    const activeOb = canvas.getActiveObject();
    if(activeOb && activeOb.type === 'text'){
        activeOb.set({ text: this.value });
        canvas.renderAll();
        drawHistory.updateCanvasState(canvas, id);
    }
});



bold.addEventListener('change',function(){
  dtEditText('bold');
});

italic.addEventListener('change',function(){
  dtEditText('italic');
});

function dtEditText(action){
  const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
    const canvas = window.canvases?.[activeSide];
    if (!canvas) return;

    const activeOb = canvas.getActiveObject();
  var o,t,
      a = action;
  o = canvas.getActiveObject();
  sCAle = o.scaleX;
  if(o){
    t = o.get('type');
  }
  if(o && t === 'text' || t === 'text-curved' || type === 'curvedText'){
    switch(a){
      case 'bold':
        var isBold = dtGetStyle(o, 'fontWeight') === 'bold';
        dtSetStyle(o, 'fontWeight', isBold ? '' : 'bold');
        break;
        
      case 'italic':
        var isItalic = dtGetStyle(o, 'fontStyle') === 'italic';
        dtSetStyle(o, 'fontStyle', isItalic ? '' : 'italic');
        break;
    }
  }
  o.scaleX = .5;
  o.setCoords();
  canvas.renderAll();
  o.scaleX = sCAle;
  o.setCoords();
  canvas.renderAll();
  drawHistory.updateCanvasState(canvas,id);
}

function dtGetStyle(object,styleName){
  return object[styleName];
}

function dtSetStyle(object,styleName,value){
  object.set(styleName,value);
}

function loadColorPicker(colorBox){
  jQuery('#'+colorBox).colorpicker({
    inline: true,
    container: true,
    extensions:[{
      name: 'swatches',
      options:{
        colors:{
          'tetrad1': 'transparent',
          'tetrad2': '#e30405',
          'tetrad3': '#197b30',
          'tetrad4': '#0054a5',
          'tetrad5': '#ffcc00',
          'tetrad6': '#f6ebbe',
          'tetrad7': '#ffea00',
          'tetrad8': '#f8931d',
          'tetrad9': '#f499c2',
          'tetrad10': '#959595',
          'tetrad11': '#fef335',
          'tetrad12': '#a0400d',
          'tetrad13': '#000000',
          'tetrad14': '#604973',
          'tetrad15': '#afe8fc',
          'tetrad16': '#fffafa',
          'tetrad17': '#bc8cbe',
          'tetrad18': '#ff69b4',
          'tetrad19': '#93278f',
          'tetrad20': '#009987',
          'tetrad21': '#0af447',
          'tetrad22': '#00008b',
          'tetrad23': '#006400'
        },
        namesAsValues: false
      }
    }],
    template: '<div class="colorpicker">' +
      '<div class="colorpicker-saturation"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-hue"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-alpha">' +
      '   <div class="colorpicker-alpha-color"></div>' +
      '   <i class="colorpicker-guide"></i>' +
      '</div>' +
      '<div class="colorpicker-bar">' +
      '   <a href="javascript:void(0);" class="button btn-block colorOFF">Ok</a>'+
      '   <div class="ctn-icon-eyedropper dropper-eyedrop"><svg class="icon icon-eyedropper" viewBox="0 0 16 16">'+
      '   <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5'+
      '   0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207'+
      '   1.207 0 0 0 0-1.708zM2 12.707l7-7L10.293 7l-7 7H2z"/></svg></div>'+
      '</div>' +
      '</div>'
  }).on('colorpickerCreate', function(){
    const $colorBox = jQuery(this);
    setTimeout(() => {
      const active = $colorBox.find('.currentColor');
      const activeCOLOR = active.attr('value');
      $colorBox.find('.colorBox').css('background', activeCOLOR);
    }, 200);
  }).on('colorpickerChange', function(){
    const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
    let canvas = window.canvases[activeSide];
    if (!canvas) return;

    const $colorBox = jQuery(this);
    setTimeout(() => {
      const active = $colorBox.find('.currentColor');
      const activeCOLOR = active.attr('value');
      $colorBox.find('.colorBox').css('background', activeCOLOR);
      $colorBox.attr('data-color', activeCOLOR);

      // Update brush color
      if(canvas.freeDrawingBrush){
        canvas.freeDrawingBrush.color = activeCOLOR;
        if(canvas.freeDrawingBrush.getPatternSrc){
          canvas.freeDrawingBrush.source = canvas.freeDrawingBrush.getPatternSrc.call(canvas.freeDrawingBrush);
        }
        updateBrush(canvas);
      }

      // Update active object color
      const activeOb = canvas.getActiveObject();
      if(activeOb){
        const sCAle = activeOb.scaleX;
        if($colorBox.attr('id') === 'textColor' && activeOb.type === 'text'){
          activeOb.set('fill', activeCOLOR);
        }
        if($colorBox.attr('id') === 'line-color'){
          activeOb.stroke = activeCOLOR;
        }
        if($colorBox.attr('id') === 'shade-color' && activeOb.shadow){
          activeOb.shadow.color = activeCOLOR;
        }
        activeOb.scaleX = 0.5;
        activeOb.setCoords();
        canvas.renderAll();
        activeOb.scaleX = sCAle;
        activeOb.setCoords();
        canvas.renderAll();
        drawHistory.updateCanvasState(canvas,id);
      }
    }, 200);
  });
  jQuery(document).on('click','.colorBox',function(){
    jQuery('.colorBox').each(function(){
      jQuery(this).next().hide();
    });
    jQuery(this).next().show();
  });
  jQuery(document).on('click','.colorOFF',function(){
    var parENt = jQuery(this).parent().parent(),
        toolBarBox = parENt.parent().parent().parent().attr('id');
    if(toolBarBox === 'labelBase'){
      parENt.parent().parent().parent().parent().removeClass('active');
    }else{
      parENt.hide();
    }
  });
}

// jQuery(document).on('click','.dropper-eyedrop',function(){
//   const eyeDropper = new EyeDropper();
//   eyeDropper.open().then(result => {
//     jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
//   }).catch(e => {
//     console.error(e);
//   });
// });


jQuery(document).on('click','.dropper-eyedrop',function(){
    var $this = jQuery(this);

    // 1. FOR DESKTOP: Use the Native EyeDropper API
    if (typeof EyeDropper !== 'undefined') {
        const eyeDropper = new EyeDropper();
        eyeDropper.open().then(result => {
            $this.closest('.colorpicker').colorpicker('setValue', result.sRGBHex);
        }).catch(e => {
            console.error(e);
        });
    } 
    // 2. FOR MOBILE: Use the HTML5 <input type='color'> fallback
    else {
        // Check if our hidden input exists, if not create it
        if(jQuery('#mobile-color-fallback').length === 0) {
            // We add it to the body, hidden but usable
            jQuery('body').append('<input type="color" id="mobile-color-fallback" style="position:absolute; left:-99px; top:-99px;">');
        }

        var $fallbackInput = jQuery('#mobile-color-fallback');
        
        // Set the current color of the input to match the picker (optional but good UX)
        var currentColor = $this.closest('.colorpicker').colorpicker('getValue');
        $fallbackInput.val(currentColor || '#000000');

        // Bind the change event to update your color picker when user picks a color
        $fallbackInput.off('input').on('input', function(e) {
            var selectedColor = e.target.value;
            // Update your plugin with the selected color
            $this.closest('.colorpicker').colorpicker('setValue', selectedColor);
        });

        // Programmatically open the mobile color picker
        $fallbackInput.trigger('click');
    }
});


document.getElementById('fontFamily').addEventListener('change', function(){
    const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
    const canvas = window.canvases?.[activeSide];
    if (!canvas) return;

    const activeOb = canvas.getActiveObject();
    if(activeOb && activeOb.type === 'text'){
        activeOb.set({ fontFamily: this.value });
        canvas.renderAll();
        drawHistory.updateCanvasState(canvas, id);
    }
});



jQuery(document).on('change','#fSize',function(){
  const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
    const canvas = window.canvases?.[activeSide];
    if (!canvas) return;

    const activeOb = canvas.getActiveObject(); 

  fontSize = jQuery(this).val();
  if(activeOb){
    sCAle = activeOb.scaleX;
    type = activeOb.get('type');
    if(type === 'text' || type === 'curvedText'){
      activeOb.set('fontSize',fontSize);
    }
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
    drawHistory.updateCanvasState(canvas,id);
  }
});

jQuery(document).on('change','input[name="text-align"]',function(){
  const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
  const canvas = window.canvases?.[activeSide];
  if (!canvas) return;

  const activeOb = canvas.getActiveObject();
  alignment = jQuery(this).val();
  if(activeOb){
    type = activeOb.get('type');
    if(type === 'text' || type === 'curvedText'){
      activeOb.set('textAlign',alignment);
    }
    activeOb.setCoords();
    canvas.renderAll();
    drawHistory.updateCanvasState(canvas,id);
  }
});

jQuery(document).on('click','.side-02 .popupBox .drop_down_catgory img',function(){
  current = jQuery(this);
  addImageToCanvas(current);
});

function addImageToCanvas(clickedImage){ 
  const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
  let canvas = window.canvases[activeSide]; // use let, not const

  if (!canvas) return; // safety check

  const imgSrc = clickedImage.attr('data-src');
  const zoom = canvas.getZoom() || 1;

  const imgObj = new Image();
  imgObj.src = imgSrc;
  imgObj.onload = function(){
    const image = new fabric.Image(imgObj);
    image.set({
      originX:"center",
      originY:"center",
      scaleX: 1,
      scaleY: 1,
      left: (canvas.getWidth() / 2) / zoom,
      top: (canvas.getHeight() / 2) / zoom
    });
    const canvasWidth = canvas.getWidth();
    image.scaleToWidth(canvasWidth * 0.5); // always 50% of canvas
    canvas.add(image).setActiveObject(image);
    canvas.renderAll();
  }
}

function deleteHandler(eventData,transform){
  const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
    const canvas = window.canvases?.[activeSide];
    if (!canvas) return;

    const activeOb = canvas.getActiveObject();
  var target = transform.target;
  canvas.remove(activeOb);
  canvas.renderAll();
}
  
jQuery(document).on('click','#addThumb',function(){
  var size = 2000;//jQuery('.product__media-outer').innerWidth('4000');
  jQuery('#loader').show();
   canvasMakeImg(canvas,size,name);
  jQuery('.canvas_div').hide();
  imgData = canvas.toDataURL("image/png");
  fetch('//technology-architects.com/tasweer-modules/save_image.php',{
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      imageData: imgData
    })
  })
  .then(response => response.text())
  .then(data => {
    console.log(data);
    jQuery('.product__media-outer').innerWidth('248');
    
    jQuery('#previewImg').val(data);
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
    
    canvasBlock(canvas,name);
    jQuery('.canvas_div').show();
    jQuery('#loader').hide();
  })
  .catch(error => console.error('Error uploading images:', error));
});

var optS,optD,options,sides = 0;
var temp = 250, orig = 2000;

jQuery(document).on('click','#addT_Shirt',function(){

  jQuery('#loader').show();
  jQuery('.canvas_div').hide();

  const active = getActiveCanvasInfo();

  if (!active) {
    console.error("No canvas selected");
    jQuery('#loader').hide();
    jQuery('.canvas_div').show();
    return;
  }

  const activeCanvas = active.canvas;
  const activeId = active.id; // top / sid / frt

  // ✅ RESET ALL FIRST (IMPORTANT)
  window['do_top'] = 0;
  window['do_sid'] = 0;
  window['do_frt'] = 0;

  window['tempBase_top'] = '';
  window['tempBase_sid'] = '';
  window['tempBase_frt'] = '';

  window['origBase_top'] = '';
  window['origBase_sid'] = '';
  window['origBase_frt'] = '';

  // ✅ RUN ONLY ACTIVE CANVAS
  doImage(activeCanvas, activeId);

  fetch('//technology-architects.com/tasweer-modules/save_tissuBox.php',{
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      do_top: window['do_top'],
      do_sid: window['do_sid'],
      do_frt: window['do_frt'],
      temp_top: window['tempBase_top'],
      orig_top: window['origBase_top'],
      temp_sid: window['tempBase_sid'],
      orig_sid: window['origBase_sid'],
      temp_frt: window['tempBase_frt'],
      orig_frt: window['origBase_frt'],
    })
  })
  .then(response => response.json())
  .then(data => {

    var prId = data.id,
        tImg = data.top_url,
        sImg = data.sid_url,
        fImg = data.frt_url;

    // ✅ CLEAR OLD INPUTS (VERY IMPORTANT)
    jQuery('#ptExtraImg, #psExtraImg, #pfExtraImg').remove();

    jQuery('#previewImg').val(prId);

    // ✅ ONLY ONE WILL EXIST NOW
    if(tImg){
      jQuery('.sides_preView').append('<input type="hidden" id="ptExtraImg" name="properties[Top_Image]" value="' + tImg + '">');
    }
    if(sImg){
      jQuery('.sides_preView').append('<input type="hidden" id="psExtraImg" name="properties[Side_Image]" value="' + sImg + '">');
    }
    if(fImg){
      jQuery('.sides_preView').append('<input type="hidden" id="pfExtraImg" name="properties[Front_Image]" value="' + fImg + '">');
    }

    jQuery('.canvas_div').show();
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
    jQuery('#loader').hide();

  })
  .catch(error => {
    console.error('Error uploading images:', error);
    jQuery('#loader').hide();
    jQuery('.canvas_div').show();
  });

});



function doImage(canvas,id){

  if (!canvas) return;

  window['do_'+id] = 0;

  // ✅ ignore safeArea while checking objects
  const realObjects = canvas.getObjects().filter(obj => !obj.excludeFromExport);

  if(realObjects.length > 0){
    sides++;
    window['do_'+id] = 1;
  }

  // ================= TEMP IMAGE =================
  canvasMakeImg(canvas,temp,id);

  // ❌ REMOVE SAFE AREA BEFORE EXPORT
  if (canvas._safeArea) {
    canvas.remove(canvas._safeArea);
  }

  loadWaterMark(canvas,id);

  window['tempBase_'+id] = canvas.toDataURL({
    format: 'png',
    quality: 1.0
  });

  // ================= ORIGINAL IMAGE =================
  canvasMakeImg(canvas,orig,id);

  removeWaterMark(canvas);

  window['origBase_'+id] = canvas.toDataURL({
    format: 'png',
    quality: 1.0
  });

  // ✅ restore safe area AFTER export
  if (typeof addSafeArea === "function") {
    addSafeArea(canvas,id);
  }

  canvasBlock(canvas,id);
}

var loadedObject;
function loadWaterMark(canvas,name){
  var elem = document.getElementById(name+'_svg'),
      svgStr = elem.innerHTML;
  // removeGuideBoxes();
  fabric.loadSVGFromString(svgStr, function(objects,options){
    const baseWidth = baseDims[name]?.width;
    const baseHeight = baseDims[name]?.height;
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(baseWidth);
    loadedObject.set({
      left: baseWidth / 2,
      top: baseHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.setCoords();
    canvas.renderAll();
  });
}

function removeWaterMark(canvas){
  canvas.remove(loadedObject).renderAll();
}


jQuery(document).on('click','#addDrawing',function(){
  const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
  let canvas = window.canvases[activeSide];

  if (!canvas) return; // safety check

  drawingModule(canvas);   // use canvas directly

  canvas.isDrawingMode = true; // enable drawing mode
  canvas.discardActiveObject();
  canvas.renderAll();

  updateBrush(canvas);
  jQuery('#drawing-mode-options').show();
});

jQuery(document).on('click','#clear-canvas',function(){
  const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
    const canvas = window.canvases?.[activeSide];
    if (!canvas) return;

    const activeOb = canvas.getActiveObject();
  canvas.clear().renderAll();
});

jQuery(document).on('click','#closeDrawing',function(){
  jQuery('.side').each(function(){
    const sideId = jQuery(this).attr('id')?.replace('Section','');
    let canvas = window.canvases[sideId]; // use let
    if (!canvas) return;

    canvas.isDrawingMode = false; // safe way to disable drawing
    canvas.renderAll();
  });
});

function updateBrush(canvas){
  current = jQuery('#drawing-mode-selector').val();
  var select = document.getElementById('drawing-mode-selector');
  var items = select.getElementsByTagName('option');
  var index = Math.floor(Math.random() * items.length);
  select.selectedIndex = index;
  setTimeout(function(){
    jQuery('#drawing-mode-selector').val(current).change();
  },50)
}

function drawingModule(canvas){
  var $ = function(elem){
    return document.getElementById(elem)
  };
  
  fabric.Object.prototype.transparentCorners = false;

  var drawingModeEl = $('drawing-mode'),
      drawingOptionsEl = $('drawing-mode-options'),
      drawingColorEl = $('drawing-color'),
      drawingShadowColorEl = $('drawing-shadow-color'),
      drawingLineWidthEl = $('drawing-line-width'),
      drawingShadowWidth = $('drawing-shadow-width'),
      drawingShadowOffset = $('drawing-shadow-offset'),
      dLW = $('dLW'),
      dSw = $('dSw'),
      dSo = $('dSo');

drawingModeEl.onclick = function() {
  const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
  let canvas = window.canvases[activeSide]; // use let

  if (!canvas) return;

  canvas.isDrawingMode = !canvas.isDrawingMode;
  if (canvas.isDrawingMode) {
    drawingModeEl.innerHTML = 'Cancel drawing mode';
    drawingOptionsEl.style.display = '';
  } else {
    drawingModeEl.innerHTML = 'Enable drawing mode';
    drawingOptionsEl.style.display = 'none';
  }
};

  if (fabric.PatternBrush) {
    var vLinePatternBrush = new fabric.PatternBrush(canvas);
    vLinePatternBrush.getPatternSrc = function() {

      var patternCanvas = fabric.document.createElement('canvas');
      patternCanvas.width = patternCanvas.height = 10;
      var ctx = patternCanvas.getContext('2d');

      ctx.strokeStyle = this.color;//getAttribute('data-color');
      ctx.lineWidth = 5;
      ctx.beginPath();
      ctx.moveTo(0, 5);
      ctx.lineTo(10, 5);
      ctx.closePath();
      ctx.stroke();

      return patternCanvas;
    };

    var hLinePatternBrush = new fabric.PatternBrush(canvas);
    hLinePatternBrush.getPatternSrc = function() {

      var patternCanvas = fabric.document.createElement('canvas');
      patternCanvas.width = patternCanvas.height = 10;
      var ctx = patternCanvas.getContext('2d');

      ctx.strokeStyle = this.color;//getAttribute('data-color');
      ctx.lineWidth = 5;
      ctx.beginPath();
      ctx.moveTo(5, 0);
      ctx.lineTo(5, 10);
      ctx.closePath();
      ctx.stroke();

      return patternCanvas;
    };

    var squarePatternBrush = new fabric.PatternBrush(canvas);
    squarePatternBrush.getPatternSrc = function() {

      var squareWidth = 10, squareDistance = 2;

      var patternCanvas = fabric.document.createElement('canvas');
      patternCanvas.width = patternCanvas.height = squareWidth + squareDistance;
      var ctx = patternCanvas.getContext('2d');

      ctx.fillStyle = this.color;//getAttribute('data-color');
      ctx.fillRect(0, 0, squareWidth, squareWidth);

      return patternCanvas;
    };

    var diamondPatternBrush = new fabric.PatternBrush(canvas);
    diamondPatternBrush.getPatternSrc = function() {

      var squareWidth = 10, squareDistance = 5;
      var patternCanvas = fabric.document.createElement('canvas');
      var rect = new fabric.Rect({
        width: squareWidth,
        height: squareWidth,
        angle: 45,
        fill: this.color//getAttribute('data-color')
      });

      var canvasWidth = rect.getBoundingRect().width;

      patternCanvas.width = patternCanvas.height = canvasWidth + squareDistance;
      rect.set({ left: canvasWidth / 2, top: canvasWidth / 2 });

      var ctx = patternCanvas.getContext('2d');
      rect.render(ctx);

      return patternCanvas;
    };

    var img = new Image();
    img.src = honeyImg;

    var texturePatternBrush = new fabric.PatternBrush(canvas);
    texturePatternBrush.source = img;
  }
  
  const drawingModeSelector = document.getElementById('drawing-mode-selector');

drawingModeSelector.onchange = function() {
    const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
    let canvas = window.canvases[activeSide]; // use let instead of const

    if (!canvas) return; // safety check

    // assign the correct brush
    if (this.value === 'hline') {
      canvas.freeDrawingBrush = vLinePatternBrush;
    }
    else if (this.value === 'vline') {
      canvas.freeDrawingBrush = hLinePatternBrush;
    }
    else if (this.value === 'square') {
      canvas.freeDrawingBrush = squarePatternBrush;
    }
    else if (this.value === 'diamond') {
      canvas.freeDrawingBrush = diamondPatternBrush;
    }
    else if (this.value === 'texture') {
      canvas.freeDrawingBrush = texturePatternBrush;
    }
    else {
      canvas.freeDrawingBrush = new fabric[this.value + 'Brush'](canvas);
    }

    // configure the brush
    if (canvas.freeDrawingBrush) {
      const brush = canvas.freeDrawingBrush;
      brush.color = drawingColorEl.getAttribute('data-color');
      if (brush.getPatternSrc) {
        brush.source = brush.getPatternSrc.call(brush);
      }
      brush.width = parseInt(drawingLineWidthEl.value, 10) || 1;
      brush.shadow = new fabric.Shadow({
        blur: parseInt(drawingShadowWidth.value, 10) || 0,
        offsetX: 0,
        offsetY: 0,
        affectStroke: true,
        color: drawingShadowColorEl.getAttribute('data-color'),
      });
    }
};

// === Brush color
drawingColorEl.onchange = function() {    
    const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
    let canvas = window.canvases[activeSide]; // use let

    if (!canvas) return; // safety check

    if (canvas.freeDrawingBrush) {
        canvas.freeDrawingBrush.color = this.getAttribute('data-color');
        if (canvas.freeDrawingBrush.getPatternSrc) {
            canvas.freeDrawingBrush.source = canvas.freeDrawingBrush.getPatternSrc.call(canvas.freeDrawingBrush);
        }
    }
};
// === Shadow color
drawingShadowColorEl.onchange = function() {
    const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
    let canvas = window.canvases[activeSide];

    if (!canvas) return;

    if (canvas.freeDrawingBrush && canvas.freeDrawingBrush.shadow) {
        canvas.freeDrawingBrush.shadow.color = this.value;
    }
};
// === Line width
drawingLineWidthEl.onchange = function() {
    const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
    let canvas = window.canvases[activeSide];

    if (!canvas) return;

    if (canvas.freeDrawingBrush) {
        canvas.freeDrawingBrush.width = parseInt(this.value, 10) || 1;
        dLW.innerHTML = this.value;
        updateBrush(canvas);
    }
};
// === Shadow blur
drawingShadowWidth.onchange = function() {
    const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
    let canvas = window.canvases[activeSide];

    if (!canvas) return;

    if (canvas.freeDrawingBrush && canvas.freeDrawingBrush.shadow) {
        canvas.freeDrawingBrush.shadow.blur = parseInt(this.value, 10) || 0;
        dSw.innerHTML = this.value;
    }
};
// === Shadow offset
drawingShadowOffset.onchange = function() {
    const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
    let canvas = window.canvases[activeSide];

    if (!canvas) return;

    if (canvas.freeDrawingBrush && canvas.freeDrawingBrush.shadow) {
        const offset = parseInt(this.value, 10) || 0;
        canvas.freeDrawingBrush.shadow.offsetX = offset;
        canvas.freeDrawingBrush.shadow.offsetY = offset;
        dSo.innerHTML = this.value;
    }
};
  
  if (canvas.freeDrawingBrush) {
    canvas.freeDrawingBrush.color = drawingColorEl.getAttribute('data-color');
    //canvas.freeDrawingBrush.source = canvas.freeDrawingBrush.getPatternSrc.call(this);
    canvas.freeDrawingBrush.width = parseInt(drawingLineWidthEl.value, 10) || 1;
    canvas.freeDrawingBrush.shadow = new fabric.Shadow({
      blur: parseInt(drawingShadowWidth.value, 10) || 0,
      offsetX: 0,
      offsetY: 0,
      affectStroke: true,
      color: drawingShadowColorEl.getAttribute('data-color')//.value,
    });
  }
};

(function() {
  // manually initialize 2 filter backends to give ability to switch
  var webglBackend;
  try {
    webglBackend = new fabric.WebglFilterBackend();
  } catch (e) {
    console.log(e);
  }
  var canvas2dBackend = new fabric.Canvas2dFilterBackend();

  fabric.filterBackend = fabric.initFilterBackend();
  fabric.Object.prototype.transparentCorners = false;

  function getActiveCanvas() {
    const activeSide = document.querySelector('.side.active')?.id?.replace('Section','');
    return window.canvases?.[activeSide];
  }

  function applyFilter(index, filter) {
    const canvas = getActiveCanvas();
    if (!canvas) return;
    const obj = canvas.getActiveObject();
    if (!obj) return;
    obj.filters[index] = filter;
    obj.applyFilters();
    canvas.renderAll();
    drawHistory.updateCanvasState(canvas, obj.id);
  }

  function applyFilterValue(index, prop, value) {
    const canvas = getActiveCanvas();
    if (!canvas) return;
    const obj = canvas.getActiveObject();
    if (!obj || !obj.filters[index]) return;
    obj.filters[index][prop] = value;
    obj.applyFilters();
    canvas.renderAll();
    drawHistory.updateCanvasState(canvas, obj.id);
  }

  const $ = id => document.getElementById(id);

  $('grayscale').onclick = function() {
    applyFilter(0, this.checked ? new fabric.Image.filters.Grayscale() : null);
  };
  $('average').onclick = function() {
    applyFilterValue(0, 'mode', 'average');
  };
  $('luminosity').onclick = function() {
    applyFilterValue(0, 'mode', 'luminosity');
  };
  $('lightness').onclick = function() {
    applyFilterValue(0, 'mode', 'lightness');
  };
  $('invert').onclick = function() {
    applyFilter(1, this.checked ? new fabric.Image.filters.Invert() : null);
  };
  $('remove-color').onclick = function () {
    applyFilter(2, this.checked ? new fabric.Image.filters.RemoveColor({
      distance: $('remove-color-distance').value,
      color: $('remove-color-color').value,
    }) : null);
  };
  $('remove-color-color').onchange = function() {
    applyFilterValue(2, 'color', this.value);
  };
  $('remove-color-distance').oninput = function() {
    applyFilterValue(2, 'distance', this.value);
  };
  $('sepia').onclick = function() {
    applyFilter(3, this.checked ? new fabric.Image.filters.Sepia() : null);
  };
  $('brownie').onclick = function() {
    applyFilter(4, this.checked ? new fabric.Image.filters.Brownie() : null);
  };
  $('brightness').onclick = function () {
    applyFilter(5, this.checked ? new fabric.Image.filters.Brightness({
      brightness: parseFloat($('brightness-value').value)
    }) : null);
  };
  $('brightness-value').oninput = function() {
    applyFilterValue(5, 'brightness', parseFloat(this.value));
  };
  $('vintage').onclick = function() {
    applyFilter(7, this.checked ? new fabric.Image.filters.Vintage() : null);
  };
  $('technicolor').onclick = function() {
    applyFilter(8, this.checked ? new fabric.Image.filters.Technicolor() : null);
  };
  $('polaroid').onclick = function() {
    applyFilter(9, this.checked ? new fabric.Image.filters.Polaroid() : null);
  };
  $('kodachrome').onclick = function() {
    applyFilter(10, this.checked ? new fabric.Image.filters.Kodachrome() : null);
  };
  $('blackwhite').onclick = function() {
    applyFilter(11, this.checked ? new fabric.Image.filters.BlackWhite() : null);
  };
})();